import { useState } from 'react';

function useToggle({ defaultValue, value, onChange }) {
    const defaultChecked = value !== null && value !== void 0 ? value : defaultValue;
    const [checked, setChecked] = useState(Boolean(defaultChecked));
    const handleChange = (e) => {
        if (value === undefined) {
            setChecked(e.target.checked);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    return {
        checked: value !== null && value !== void 0 ? value : checked,
        onChange: handleChange,
    };
}

export { useToggle };
//# sourceMappingURL=useToggle.js.map
